import './App.css';
import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import axios from 'axios';
import { Toaster } from 'react-hot-toast';
import CustomerExperience from './component/Experience/CustomerExperience';
import MainContainer from './component/Reviews/MainContainer';
import QrReview from './component/Reviews/QrCodeReview';
import QrExperience from './component/Experience/QrExperience';
import Thankexperience from './component/Experience/Thankexperience';
import ThankReviews from './component/Reviews/ThankReviews';
import WriteReview from './component/Reviews/WriteReviews';
import MainReferral from './component/Referal/MainReferal';
import SelfReferral from './component/Referal/SelfReferral';
import SingleReferral from './component/Referal/SingleReferral';
import CheckIn from './component/ReviewOptions/Checkin/CheckIn';
import GiveReview from './component/ReviewOptions/WriteReview/GiveReview';
import ReviewUrl from './component/ReviewOptions/ReviewURL/ReviewUrl';
import ReviewProfile from './component/ReviewOptions/ReviewProfile/ReviewProfile';
import ThankReviewsPage from './component/Reviews/ThankReviewsPage';
import Redirect from './Redirect';
import Unsubscribe from './component/Unsubscribe';
import Custom from './component/Custom/Custom';
import ResetpasswordPage from './component/ResetPasswordPage';
import SignupForm from './component/SignupForm/SignupForm';

const baseURL = process.env.REACT_APP_BASE_URL;
const config = {
  Accept: 'application/json',
  headers: {
    // Authorization: `Bearer ${token}`,
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
};

function App() {
  useEffect(() => {
    handleFetchDomainDetails();
  }, []);

  const handleFetchDomainDetails = async () => {
    const hostId = window.location.host.split('.').slice(-2).join('.');
    const res = await axios.get(`${baseURL}/internal/accounts/fetch-hosts/${hostId}`, config);
    if (res?.data?.status === 'success') {
      const domainDetails = res?.data?.data[0];
      if (domainDetails) {
        localStorage.setItem('h_name', domainDetails?.name);
        localStorage.setItem('h_url', domainDetails?.logo);
        document.title = domainDetails?.name;
        const newLink = document.createElement('link');
        newLink.rel = 'icon';
        newLink.href = domainDetails?.logo;
        document.head.appendChild(newLink);
      } else {
        localStorage.removeItem('h_name');
        localStorage.removeItem('h_url');
        document.title = 'SalesCaptain';
        const newLink = document.createElement('link');
        newLink.rel = 'icon';
        newLink.href = 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2024-10-15/webchat_1728990607600.png';
        document.head.appendChild(newLink);
      }
    }
  };
  return (
    <div className="APP_container">
      <Toaster
        position="top-center"
        reverseOrder={false}
      />

      <Routes>
        <Route path="unsubscribe/:companyid/:contactid/:type" element={<Unsubscribe baseURL={baseURL} />} />
        <Route path="signup-form/:companyId" element={<SignupForm baseURL={baseURL} />} />

        <Route path=":id" element={<Redirect baseURL={baseURL} />} />
        <Route path=":companyid/checkin" element={<CheckIn baseURL={baseURL} />} />
        <Route path=":companyid/review-us" element={<GiveReview baseURL={baseURL} />} />
        <Route path=":companyid/review-url" element={<ReviewUrl baseURL={baseURL} />} />
        <Route path=":companyid/profile" element={<ReviewProfile baseURL={baseURL} />} />

        {/* <Route path="reviews/:linkid/:templateid/:contactid/"
         element={<MainContainer baseURL={baseURL} />} /> */}
        <Route path="reviews/:linkid/:templateid/:contactid/:type" element={<MainContainer baseURL={baseURL} />} />
        <Route path="reviews/:id" element={<QrReview baseURL={baseURL} />} />
        <Route path="reviews/:templateid/:contactid" element={<WriteReview />} />
        
        <Route path="customerexperience/:linkid/:templateid/:contactid/:type/:rate" element={<CustomerExperience baseURL={baseURL} />} />
        <Route path="customerexperience/:id" element={<QrExperience baseURL={baseURL} />} />
        {/* <Route path="customerexperience/:linkid/:templateid/:contactid/sms"
         element={<CustomerExperience baseURL={baseURL} />} /> */}
        {/* <Route path="reviewus/:linkid/:templateid/:contactid/:type" 
        element={<MainContainer baseURL={baseURL} />} /> */}
        <Route path="referal/:linkid/:templateid/:contactid/:type" element={<MainReferral baseURL={baseURL} />} />
        {/* <Route path="referal/:linkid/:templateid/:contactid" element={<MainReferral/> }/> */}
        <Route path="/sr/:linkid/:value/:templateid/:contactid/:type" element={<SelfReferral baseURL={baseURL} />} />
        <Route path="/sr/:linkid/:value/:templateid/:contactid/:type" element={<SelfReferral baseURL={baseURL} />} />
        <Route path="/r/:linkid/:templateid/:contactid" element={<SingleReferral baseURL={baseURL} />} />
        <Route path="/r/:linkid/:templateid/:contactid/email" element={<SingleReferral baseURL={baseURL} />} />

        {/* <Route path="/reviewus/:templateId/:contactId" element={<Thankexperience />} /> */}
        {/* <Route path="/reviewus/:templateid/:contactid/:type" 
        element={<MainContainer baseURL={baseURL} />} /> */}
        <Route path="/reviewus/:templateid/:contactid" element={<ThankReviewsPage baseURL={baseURL} />} />
        <Route path="/cx/:templateid/:contactid" element={<ThankReviewsPage baseURL={baseURL} />} />

        <Route path="/custom/:id" element={<Custom baseURL={baseURL} />} />
        <Route path="reset-password/:tokenId/:userId" element={<ResetpasswordPage baseURL={baseURL} />} />
      </Routes>
    </div>
  );
}

export default App;
